import { createFileRoute } from '@tanstack/react-router'
import JobsSubmissions from '@/pages/partners/components/jobs-submissions'

export const Route = createFileRoute('/_authenticated/partners/$partnerId/')({
  component: JobsSubmissions,
})
